import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { PRODUCT_QUERY } from "../../../Config/Queries";

import Presenter from "./Presenter";
import Lodings from "../../../Components/Loading";

import NotFound from "../../NotFound";

function Container({ history, match, location }) {
  const id = match.params.id;

  const { data, loading, error } = useQuery(PRODUCT_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      id,
    },
  });

  if (error) {
    return <NotFound />;
  }

  if (!loading) {
    return <Presenter data={data} />;
  } else {
    return (
      <>
        <Lodings desc="로딩..." />
      </>
    );
  }
}

export default withRouter(Container);
